<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()" >Tasks</li>
  </app-tabs>
  <app-tasksfilter class="flex-control flex-column scroll-browser" [hidden]="tabs_service.is_active()"></app-tasksfilter>
</div>
